import { render, staticRenderFns } from "./ContentsInsurancePromoCard.vue?vue&type=template&id=5fead82b"
import script from "./ContentsInsurancePromoCard.vue?vue&type=script&lang=js"
export * from "./ContentsInsurancePromoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports